import { dequal } from "dequal";
import memoize from "memoize-one";

const dotGet = memoize((obj: any, path: any, defValue?: any): any => {
  // If path is not defined or it has false value
  if (!path) return undefined;
  // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
  // Regex explained: https://regexr.com/58j0k
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  if (pathArray) {
    return pathArray.reduce(
      (prevObj: any, key: any) => prevObj && prevObj[key],
      obj
    );
  }

  return defValue;
}, dequal);

const copyObject = <T = any>(obj: T): T => JSON.parse(JSON.stringify(obj));

const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return (
      navigator.userAgent.match(/IEMobile/i) ||
      navigator.userAgent.match(/WPDesktop/i)
    );
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};

const convertMegabytesToBytes = (megabytes: number) =>
  megabytes * Math.pow(1024, 2);

export { dotGet, isMobile, copyObject, convertMegabytesToBytes };
